import {Component, Input, AfterViewInit, OnChanges, SimpleChanges} from '@angular/core';
import {Kpi} from '../../../../models/common';
import {platformIconPath} from '../../../app.constants';
import {TranslateService} from '@ngx-translate/core';
import { PdfExportService } from '../../../services/export-pdf/pdf-export.service';

@Component({
  selector: 'new-kpi',
  templateUrl: './new-kpi.component.html',
  styleUrls: ['./new-kpi.component.scss']
})
export class NewKpiComponent implements OnChanges , AfterViewInit {
  @Input() kpi: Kpi;
  @Input() isFetchingData: boolean;

  public hasNoData: boolean;

  constructor(private translate: TranslateService,
              private pdfService: PdfExportService) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.kpi) {
      const kpi = changes.kpi.currentValue;
      this.hasNoData = kpi === null || kpi === undefined;
    }
  }

  ngAfterViewInit() {
    this.pdfService.incrementNumberReportReady('NewKpiComponent');
  }

  get engagementRateTooltip() {
    if (!this.kpi) {
      return null;
    }
    if (this.kpi.platformName && (this.kpi.platformName.toLocaleLowerCase() === platformIconPath.instagram.name.toLocaleLowerCase()
        || this.kpi.platformName.toLocaleLowerCase() === platformIconPath.youtube.name.toLocaleLowerCase()
        || this.kpi.platformName.toLocaleLowerCase() === platformIconPath.blogs.name.toLocaleLowerCase()
        || this.kpi.platformName.toLocaleLowerCase() === platformIconPath.tiktok.name.toLocaleLowerCase())) {
      return this.translate.instant(`info_box.influencer.engagement_rate_${this.kpi.platformName.toLocaleLowerCase()}`);
    }
    return this.translate.instant('info_box.influencer.engagement_rate');
  }

}



// WEBPACK FOOTER //
// ./src/app/main/influencer/new-kpi/new-kpi.component.ts